export default __webpack_public_path__ + "static/media/blue-divider-top.42bb7ca2.svg";